import { SERVER_ERROR_STATUS } from "../constants/statusCodeConstants";
import { InvalidJsonFieldValue } from "./ApiResponseHelper";

const LINEAR_RETRY_DELAY = 50;

export function handleLinearRetryableRequest({
    error,
    retryAction,
    onFirstRetry,
    onMaxRetriesExceeded,
    onNonRetryableError = () => {},
    delay = LINEAR_RETRY_DELAY,
    maxRetries = 3,
    currentRetry = 0
}) {
    const isRetryableError =
        error?.status === SERVER_ERROR_STATUS ||
        InvalidJsonFieldValue.isInvalidJsonFieldError(error);

    if (isRetryableError) {
        if (currentRetry === 0 && onFirstRetry) {
            onFirstRetry();
        }

        if (currentRetry < maxRetries) {
            setTimeout(() => retryAction(currentRetry + 1), delay);
        } else if (onMaxRetriesExceeded) {
            onMaxRetriesExceeded();
        }
    } else if (onNonRetryableError) {
        onNonRetryableError();
    }
}
